import React, { FC } from 'react';
import { Stack } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

export const LoadingSkeleton: FC = () => {
  return (
    <Stack direction="column" gap="14px">
      <Skeleton variant="rounded" width="100%" height={38} />
      <Stack direction="column" gap="14px">
        <Skeleton variant="rounded" width="100%" height={42} />
        <Stack direction="column" gap="14px">
          <Skeleton variant="rounded" width="100%" height={22} />
          <Skeleton variant="rounded" width="100%" height={22} />
          <Skeleton variant="rounded" width="100%" height={22} />
          <Skeleton variant="rounded" width="100%" height={22} />
        </Stack>
        <Skeleton variant="rounded" width="100%" height={24} />
      </Stack>
      <Skeleton variant="rounded" width="100%" height={34} />
    </Stack>
  );
};
